import { ReactNode } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

interface DropdownItem {
  value: string;
  trigger: string;
  content: ReactNode;
}

interface DropdownProps {
  items: DropdownItem[];
  className?: string;
  triggerClassName?: string;
  contentClassName?: string;
}

const Dropdown = ({ ...props }: DropdownProps) => {
  return (
    <Accordion type="single" collapsible className="w-full">
      {props.items?.map((item, i: number) => {
        return (
          <AccordionItem className={props.className} value={item.value} key={i}>
            <AccordionTrigger className={props.triggerClassName}>
              {item.trigger}
            </AccordionTrigger>
            <AccordionContent className={`text-lg ${props.contentClassName}`}>
              {item.content}
            </AccordionContent>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};

export default Dropdown;
